export enum CaptionType {
  TIKTOK = 'tiktokCaption',
  YOUTUBE = 'youtubeCaption',
  INSTAGRAM = 'instagramCaption',
  PINTEREST = 'pinterestCaption'
}

export enum CaptionToggleType {
  TIKTOK = 'tiktokToggle',
  YOUTUBE = 'youtubeToggle',
  INSTAGRAM = 'instagramToggle',
  PINTEREST = 'pinterestToggle'
}

export enum CaptionToggleRemoveType {
  LINKEDIN = 'linkedinToggle',
  FACEBOOK = 'facebookToggle',
  TWITTER = 'twitterToggle'
}

export enum CaptionAutoPostToggle {
  TIKTOK = 'tiktokAutoPostToggle',
  YOUTUBE = 'youtubeAutoPostToggle',
  INSTAGRAM = 'instagramAutoPostToggle',
  PINTEREST = 'pinterestAutoPostToggle'
}
